<div class="is-content-section-fields">
	<div class="is-content-section-field">
		<p class="is-label">{{ 'financial-movements.registrationDate' | translate }}</p>
		<p class="is-value">{{ (aggregateDocument?.Document?.CreationDate | dateLocale: 'yyyy/MM/dd') || '-' }}</p>
	</div>
	<div class="is-content-section-field">
		<p class="is-label">{{ 'financial-movements.confirmedPaymentDate' | translate }}</p>
		<p class="is-value">{{ (aggregateDocument?.Document?.BuyerPaymentDate | dateLocale: 'yyyy/MM/dd') || '-' }}</p>
	</div>
	<div class="is-content-section-field">
		<p class="is-label">{{ 'financial-movements.requestDate' | translate }}</p>
		<p class="is-value">{{ (aggregateDocument?.FinancialRequestSubmissionDate | dateLocale: 'yyyy/MM/dd') || '-' }}</p>
	</div>
	<div class="is-content-section-field">
		<p class="is-label">{{ 'financial-movements.request' | translate }}</p>
		<p class="is-value">{{ aggregateDocument?.FinancialRequestSequenceNumber || '-' }}</p>
	</div>
	<div class="is-content-section-field">
		<p class="is-label">{{ 'financial-movements.requestStatus' | translate }}</p>
		<span class="tag financial-movement-state-{{ aggregateDocument?.FinancialRequestState }}">
			{{ aggregateDocument?.FinancialRequestState }}
		</span>
	</div>
</div>
